import { useId, useState } from 'react';
import { useReveal } from '../hooks/useReveal.js';
import { ChevronDown } from '../components/icons.js';

type Item = { q: string; a: string };

const items: Item[] = [
  {
    q: 'Is Orthodox Way affiliated with a specific jurisdiction?',
    a: 'No. We follow the typikon used across the canonical Orthodox jurisdictions. You can choose Old Calendar, Revised Julian, or New Calendar in settings. Where typika differ, we cite our source.',
  },
  {
    q: 'Is it free?',
    a: 'The core experience, Today, prayers, fasting, readings, services, learning, is free, forever. We may offer optional premium features for parishes (advanced admin, analytics) in future, but the daily life of the faithful will never be paywalled.',
  },
  {
    q: 'Does it work offline?',
    a: 'Yes. Once you’ve opened the app, your prayer rule, today’s fasting and readings, and the Jesus Prayer rope all work offline. The liturgical engine runs on-device.',
  },
  {
    q: 'What about non-Orthodox users? Catechumens? Inquirers?',
    a: 'You are welcome. Many of our most attentive users are catechumens. The Learning module is built especially for the early journey.',
  },
  {
    q: 'How is my data handled?',
    a: 'Your prayer logs, fasting history, and reflection notes belong to you. Reflections are encrypted at rest. We do not sell data. We do not run ads. We do not use your spiritual practice to market to you.',
  },
  {
    q: 'Will it support languages other than English?',
    a: 'Yes - Greek, Slavonic, Romanian, and Arabic are on the roadmap. Service texts will be available in their original languages alongside English.',
  },
  {
    q: 'Can my parish use it?',
    a: 'Yes. Parish admins can manage their own service times, announcements, and events. Contact us for jurisdictional partnerships.',
  },
  {
    q: 'Who built this?',
    a: 'A small team of Orthodox developers and a layperson with a long history of building software for industries that need to be careful, banking, healthcare, government. Building software for the Church requires the same care.',
  },
];

function Row({ item, open, onToggle }: { item: Item; open: boolean; onToggle: () => void }) {
  const id = useId();
  return (
    <div className="ow-accordion-row">
      <button
        type="button"
        aria-expanded={open}
        aria-controls={`${id}-panel`}
        onClick={onToggle}
        className="ow-accordion-trigger"
      >
        <span
          className="font-display text-primary"
          style={{ fontSize: 18, fontWeight: 500, letterSpacing: '0.01em' }}
        >
          {item.q}
        </span>
        <span className="ow-chevron" aria-hidden>
          <ChevronDown />
        </span>
      </button>
      <div id={`${id}-panel`} role="region" className="ow-accordion-content" data-open={open}>
        <div>
          <p
            className="text-secondary pb-6 max-w-[640px]"
            style={{ fontSize: 16, lineHeight: 1.75 }}
          >
            {item.a}
          </p>
        </div>
      </div>
    </div>
  );
}

export function FAQ() {
  const headerRef = useReveal<HTMLDivElement>(0.3);
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section id="faq" className="relative w-full" style={{ padding: '76px 20px' }}>
      <div className="mx-auto" style={{ maxWidth: 720 }}>
        <div ref={headerRef} className="ow-reveal text-center">
          <p
            className="font-display uppercase text-gold"
            style={{ fontSize: 11, letterSpacing: '0.32em' }}
          >
            § VII - Questions
          </p>
          <h2
            className="font-display text-primary mt-5"
            style={{
              fontSize: 'clamp(32px, 5vw, 56px)',
              fontWeight: 500,
              letterSpacing: '0.02em',
            }}
          >
            Honest answers.
          </h2>
        </div>

        <div className="mt-12">
          {items.map((it, i) => (
            <Row
              key={it.q}
              item={it}
              open={open === i}
              onToggle={() => setOpen((cur) => (cur === i ? null : i))}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
